var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLandscape)?_c('ContactPc'):_c('ContactPhone')
}
var staticRenderFns = []

export { render, staticRenderFns }